import useIsMobile from '../hooks/useIsMobile';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authAPI, vehiclesAPI } from '../services/api';
import toast from 'react-hot-toast';

/* ── Máscaras ───────────────────────────── */
function maskPhone(value) {
  const n = value.replace(/\D/g, '').slice(0, 11);
  if (n.length <= 2) return n.length ? `(${n}` : '';
  if (n.length <= 7) return `(${n.slice(0,2)}) ${n.slice(2)}`;
  return `(${n.slice(0,2)}) ${n.slice(2,7)}-${n.slice(7)}`;
}

/* ── Styles ─────────────────────────────── */
const P = {
  eyebrow: { fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.8px', color: '#e97117', marginBottom: '6px' },
  h1: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, textTransform: 'uppercase', lineHeight: 0.95, letterSpacing: '-0.02em', margin: 0, color: '#14562e' },
  subtitle: { color: '#6a7268', margin: '6px 0 0', fontSize: '15px' },
  grid: { display: 'grid', gap: '24px', marginTop: '28px' },
  card: { background: '#fff', border: '1px solid #e5ddc9', borderRadius: '16px', padding: '28px' },
  avatar: {
    width: '90px', height: '90px', borderRadius: '50%', background: '#14562e', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '36px',
    margin: '0 auto 14px',
  },
  name: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '22px', color: '#14562e', textAlign: 'center', margin: 0 },
  email: { color: '#6a7268', fontSize: '13.5px', textAlign: 'center', marginTop: '4px' },
  editBtn: {
    display: 'block', width: '100%', padding: '12px', borderRadius: '12px',
    border: '1.5px solid #e5ddc9', background: 'transparent', color: '#14562e',
    fontWeight: 700, fontSize: '14px', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif", marginTop: '18px', transition: 'all 0.15s',
  },
  badgeRow: { display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap', marginTop: '18px' },
  badge: {
    background: '#e6f0e9', padding: '5px 12px', borderRadius: '999px',
    fontSize: '12px', fontWeight: 600, color: '#14562e',
    display: 'inline-flex', alignItems: 'center', gap: '5px',
  },
  settingItem: {
    display: 'flex', alignItems: 'center', gap: '14px', padding: '18px 20px',
    borderBottom: '1px solid #efe8d6', cursor: 'pointer', transition: 'background 0.15s',
  },
  settingIcon: {
    width: '42px', height: '42px', borderRadius: '12px', background: '#f4ede0',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    color: '#14562e',
  },
  settingTitle: { fontWeight: 700, fontSize: '14.5px', color: '#14562e', margin: 0 },
  settingDesc: { fontSize: '13px', color: '#6a7268', margin: '2px 0 0' },
  chevron: { marginLeft: 'auto', color: '#ccc', flexShrink: 0 },
  // Modal
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(15,64,35,.4)',
    backdropFilter: 'blur(6px)', zIndex: 200,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
  },
  modal: {
    background: '#fff', borderRadius: '22px', padding: '32px',
    maxWidth: '480px', width: '100%', maxHeight: '90vh', overflowY: 'auto',
    boxShadow: '0 20px 48px rgba(15,64,35,.14)',
  },
  modalTitle: {
    fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800,
    textTransform: 'uppercase', fontSize: '22px', color: '#14562e', margin: '0 0 20px',
  },
  label: { fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: '#6a7268', marginBottom: '6px', display: 'block' },
  input: {
    width: '100%', padding: '12px 14px', borderRadius: '10px',
    border: '1.5px solid #e5ddc9', background: '#f4ede0', color: '#183d24',
    fontFamily: "'DM Sans', sans-serif", fontSize: '14.5px',
    outline: 'none', boxSizing: 'border-box', marginBottom: '14px',
  },
  btn: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    gap: '8px', padding: '12px 22px', borderRadius: '12px',
    fontWeight: 700, fontSize: '14px', cursor: 'pointer', border: 'none',
    fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s',
  },
};

const SETTINGS = [
  { key: 'notif', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>, title: 'Notificações', desc: 'Receba lembretes por e-mail e WhatsApp' },
  { key: 'theme', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>, title: 'Aparência', desc: 'Tema claro / escuro' },
  { key: 'security', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>, title: 'Segurança', desc: 'Senha, autenticação de 2 fatores' },
  { key: 'plan', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>, title: 'Assinatura', desc: 'Plano Grátis · Faça upgrade para NICO+' },
  { key: 'help', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>, title: 'Ajuda e suporte', desc: 'Central de ajuda, contato, FAQ' },
];

const CHEVRON = <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>;

/* ── Edit Profile Modal ─────────────────── */
function EditModal({ open, onClose, user, onSaved }) {
  const [name, setName] = useState(user?.name || '');
  const [phone, setPhone] = useState(user?.phone ? maskPhone(user.phone) : '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && user) { setName(user.name || ''); setPhone(user.phone ? maskPhone(user.phone) : ''); }
  }, [open, user]);

  if (!open) return null;

  const handleSave = async () => {
    if (!name.trim()) { toast.error('Nome é obrigatório'); return; }
    setSaving(true);
    try {
      const r = await authAPI.updateProfile({ name: name.trim(), phone: phone.trim() || null });
      toast.success('Perfil atualizado! ✓');
      onSaved(r.user);
      onClose();
    } catch (err) { toast.error(err.message || 'Erro ao atualizar'); }
    finally { setSaving(false); }
  };

  return (
    <div style={P.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={P.modal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={P.modalTitle}>Editar perfil</h2>
          <button style={{ width: '36px', height: '36px', borderRadius: '10px', background: '#f4ede0', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: 'none', color: '#183d24' }} onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <label style={P.label}>Nome completo</label>
        <input style={P.input} value={name} onChange={e => setName(e.target.value)} placeholder="Seu nome" />
        <label style={P.label}>Telefone</label>
        <input style={P.input} value={phone} onChange={e => setPhone(maskPhone(e.target.value))} placeholder="(11) 99999-9999" inputMode="numeric" />
        <label style={P.label}>Email</label>
        <input style={{ ...P.input, opacity: 0.5 }} value={user?.email || ''} disabled />
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '8px' }}>
          <button style={{ ...P.btn, background: 'transparent', color: '#183d24' }} onClick={onClose}>Cancelar</button>
          <button style={{ ...P.btn, background: '#14562e', color: '#fff', opacity: saving ? 0.6 : 1 }} onClick={handleSave} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar alterações'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Password Modal ─────────────────────── */
function PasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  const handleSave = async () => {
    if (!current) { toast.error('Informe a senha atual'); return; }
    if (newPw.length < 6) { toast.error('Nova senha deve ter pelo menos 6 caracteres'); return; }
    if (newPw !== confirm) { toast.error('Senhas não coincidem'); return; }
    setSaving(true);
    try {
      await authAPI.updatePassword({ current_password: current, new_password: newPw });
      toast.success('Senha alterada! 🔒');
      setCurrent(''); setNewPw(''); setConfirm('');
      onClose();
    } catch (err) { toast.error(err.message || 'Erro ao alterar senha'); }
    finally { setSaving(false); }
  };

  return (
    <div style={P.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={P.modal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={P.modalTitle}>Alterar senha</h2>
          <button style={{ width: '36px', height: '36px', borderRadius: '10px', background: '#f4ede0', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: 'none', color: '#183d24' }} onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <label style={P.label}>Senha atual</label>
        <input style={P.input} type="password" value={current} onChange={e => setCurrent(e.target.value)} />
        <label style={P.label}>Nova senha</label>
        <input style={P.input} type="password" value={newPw} onChange={e => setNewPw(e.target.value)} placeholder="Mínimo 6 caracteres" />
        <label style={P.label}>Confirmar nova senha</label>
        <input style={P.input} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} />
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '8px' }}>
          <button style={{ ...P.btn, background: 'transparent', color: '#183d24' }} onClick={onClose}>Cancelar</button>
          <button style={{ ...P.btn, background: '#14562e', color: '#fff', opacity: saving ? 0.6 : 1 }} onClick={handleSave} disabled={saving}>
            {saving ? 'Salvando...' : 'Alterar senha'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Main Page ────────────────────────────── */
export default function ProfilePage() {
  const { user, setUser } = useAuth();
  const m = useIsMobile();
  const [profile, setProfile] = useState(null);
  const [stats, setStats] = useState({ vehicles: 0, services: 0 });
  const [loading, setLoading] = useState(true);
  const [editOpen, setEditOpen] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);

  useEffect(() => {
    Promise.all([
      authAPI.me().catch(() => null),
      vehiclesAPI.list().then(r => r.vehicles || []).catch(() => []),
    ]).then(([me, vehicles]) => {
      if (me?.user) setProfile(me.user);
      const totalServices = vehicles.reduce((sum, v) => sum + (v.services_count || 0), 0);
      setStats({ vehicles: vehicles.length, services: totalServices });
    }).finally(() => setLoading(false));
  }, []);

  const displayUser = profile || user || {};
  const initials = displayUser.name ? displayUser.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'U';
  const memberYear = displayUser.created_at ? new Date(displayUser.created_at).getFullYear() : new Date().getFullYear();

  const handleProfileSaved = (updatedUser) => {
    setProfile(updatedUser);
    if (setUser) setUser(prev => ({ ...prev, ...updatedUser }));
  };

  const handleSettingClick = (key) => {
    if (key === 'security') setPwOpen(true);
    else toast('Em breve! 🚧', { icon: '🔜' });
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', flexDirection: 'column', gap: '12px' }}>
      <div className="spinner" style={{ width: '32px', height: '32px' }} />
      <span style={{ fontSize: '13px', color: '#6a7268' }}>Carregando perfil...</span>
    </div>
  );

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: '4px' }}>
        <span style={P.eyebrow}>Sua conta</span>
        <h1 style={{ ...P.h1, fontSize: m ? '28px' : '44px' }}>Perfil</h1>
        <p style={P.subtitle}>Suas informações, preferências e assinatura.</p>
      </div>

      {/* Grid */}
      <div style={{ ...P.grid, gridTemplateColumns: m ? '1fr' : '1fr 1.4fr' }}>
        {/* Left: Profile card */}
        <div style={{ ...P.card, textAlign: 'center' }}>
          <div style={P.avatar}>{initials}</div>
          <h2 style={P.name}>{displayUser.name || 'Usuário'}</h2>

          {/* Role badge */}
          {displayUser.role === 'professional' ? (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#14562e', color: '#fff', padding: '5px 14px', borderRadius: '999px', fontSize: '12px', fontWeight: 700, marginTop: '8px', letterSpacing: '0.5px' }}>
              🔧 Conta Profissional
            </div>
          ) : (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#e6f0e9', color: '#14562e', padding: '5px 14px', borderRadius: '999px', fontSize: '12px', fontWeight: 700, marginTop: '8px', letterSpacing: '0.5px' }}>
              🚗 Dono de veículo
            </div>
          )}

          <p style={P.email}>
            {displayUser.email}
            {displayUser.phone && ` · ${displayUser.phone}`}
          </p>
          <button
            style={P.editBtn}
            onClick={() => setEditOpen(true)}
            onMouseOver={e => { e.currentTarget.style.borderColor = '#14562e'; e.currentTarget.style.background = '#e6f0e9'; }}
            onMouseOut={e => { e.currentTarget.style.borderColor = '#e5ddc9'; e.currentTarget.style.background = 'transparent'; }}
          >
            Editar perfil
          </button>
          <div style={P.badgeRow}>
            <span style={P.badge}>🚗 {stats.vehicles} veículo{stats.vehicles !== 1 ? 's' : ''}</span>
            <span style={P.badge}>👤 Membro desde {memberYear}</span>
            <span style={P.badge}>⭐ {stats.services} serviço{stats.services !== 1 ? 's' : ''}</span>
          </div>
        </div>

        {/* Right: Settings */}
        <div style={{ ...P.card, padding: 0, overflow: 'hidden' }}>
          {SETTINGS.map((s, i) => (
            <div
              key={s.key}
              style={{ ...P.settingItem, ...(i === SETTINGS.length - 1 ? { borderBottom: 'none' } : {}) }}
              onClick={() => handleSettingClick(s.key)}
              onMouseOver={e => { e.currentTarget.style.background = '#f9f5ec'; }}
              onMouseOut={e => { e.currentTarget.style.background = 'transparent'; }}
            >
              <div style={P.settingIcon}>{s.icon}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <h4 style={P.settingTitle}>{s.title}</h4>
                <p style={P.settingDesc}>{s.desc}</p>
              </div>
              <span style={P.chevron}>{CHEVRON}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Modals */}
      <EditModal open={editOpen} onClose={() => setEditOpen(false)} user={displayUser} onSaved={handleProfileSaved} />
      <PasswordModal open={pwOpen} onClose={() => setPwOpen(false)} />
    </div>
  );
}
